import { GetFunction, PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

// The customer support chat, served by the user service. The page says
// what failed itself (inline, with Try again, or "Not sent" on a message),
// so these calls show no toast of their own, except where noted.

// Every open conversation, newest first: id, name, image, last_message,
// last_message_type, date. Nothing says whether it is unread.
export const getChats = (dispatch) => GetFunction({ Route: UrlApi.chat.get_chat, showerror: false, dispatch, is_client: true });

// Messages of one conversation, newest first. offset counts messages.
// markRead false asks the server not to mark the customer's messages read
// (the chat stays unread for the team until someone replies or presses
// "Mark as read"); an API that doesn't know mark_read still marks them read
// when they are fetched. Older pages have no inline error, so a failure
// there is a toast in our words.
export const PAGE_SIZE = 50;
export const getMessages = (chatId, offset, dispatch, { markRead = true } = {}) =>
  GetFunction({
    Route: `${UrlApi.chat.get_chat_messages}?chat_id=${encodeURIComponent(chatId)}&offset=${offset}&limit=${PAGE_SIZE}${markRead ? "" : "&mark_read=0"}`,
    showerror: offset > 0 ? "The older messages did not load. Try again." : false,
    dispatch,
    is_client: true,
  });

// A file for a message; answers its stored path ("file/...").
export const uploadChatFile = (file, dispatch) => {
  const body = new FormData();
  body.append("file", file);
  return PostFunction({ Route: UrlApi.chat.upload, data: body, isMultipart: true, showalert: false, showerror: false, dispatch, is_client: true });
};

// "Mark as answered" (round 2, karim-15): a chat answered on WhatsApp or by
// phone stops waiting until the customer writes again (API migration 043,
// staff service). The list also gives each chat's customer, their latest
// case and the phone on it, for "Answer on WhatsApp". Quiet: the page says
// what failed.
export const getAnswered = (chatIds, dispatch) =>
  PostFunction({ Route: "cases/support/answered/list", data: { chat_ids: chatIds.slice(0, 500) }, isMultipart: false, showalert: false, showerror: false, dispatch });
export const setAnswered = (chatId, undo, dispatch) =>
  PostFunction({ Route: "cases/support/answered", data: { chat_id: Number(chatId), ...(undo ? { undo: true } : {}) }, isMultipart: false, showalert: false, showerror: false, dispatch });
